module.exports = __webpack_public_path__ + "img/积分红包@2x.3d8e0326.png";